import { createContext, useState, useEffect } from "react";
import { DEFAULT_THEME, DEFAULT_COLOR } from "../lib/constants";
import {
  GiHummingbird,
  GiLion,
  GiBearFace,
  GiWhaleTail,
  GiButterfly,
  GiTigerHead,
  GiDolphin,
  GiGorilla,
  GiBurningSkull,
  GiSharkFin,
  GiSharkJaws,
} from "react-icons/gi";

const AppContext = createContext({});

export const AppProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    color: localStorage.getItem("color") || DEFAULT_COLOR,
    theme: localStorage.getItem("theme") || DEFAULT_THEME,
  });

  const themes = {
    hummingbird: GiHummingbird,
    lion: GiLion,
    bear: GiBearFace,
    whale: GiWhaleTail,
    butterfly: GiButterfly,
    tiger: GiTigerHead,
    dolphin: GiDolphin,
    gorilla: GiGorilla,
    skull: GiBurningSkull,
    shark1: GiSharkFin,
    shark2: GiSharkJaws,
  };

  useEffect(() => {
    localStorage.setItem("theme", settings.theme);
    localStorage.setItem("color", settings.color);
  }, [settings]);

  return (
    <AppContext.Provider value={{ settings, setSettings, themes }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
